export default "__VITE_ASSET__bba23a34__"